import { ArrowUpRight } from "lucide-react";
import { SectionIntro } from "@/components/site/SectionHead";
import { Reveal } from "@/components/site/motion";
import { FOUNDERS } from "@/content/site";
import { PictureFrame } from "@/components/site/PictureFrame";

export const Founders = () => (
  <section id="founders" className="bg-ink-2 py-16 sm:py-20" data-testid="founders-section" data-analytics-section="founders">
    <div className="shell">
      <SectionIntro label="The team" title="Ships, meet machines." />
      <div className="mt-10 grid gap-8 md:grid-cols-2 md:gap-12">
        {FOUNDERS.map((f) => <Reveal key={f.id} data-testid={`founder-${f.id}`}>
          <div className="relative isolate flex h-[290px] items-end overflow-hidden bg-ink p-7 sm:h-[340px] sm:p-9">
            <img src={f.portrait || (f.id === "hash" ? "/media/port-night.jpg" : "/media/engine.jpg")} alt={f.portrait ? f.full : ""} loading="lazy" className={`absolute inset-0 -z-20 h-full w-full object-cover ${f.id === "kelp" ? "saturate-50" : ""}`} />
            <div className="absolute inset-0 -z-10 bg-gradient-to-t from-ink via-ink/10 to-ink/20" />
            <PictureFrame />
            <div className="relative"><p className="eyebrow text-signal">{f.side}</p><h3 className="mt-3 text-6xl font-[520] tracking-[-.05em] text-white sm:text-7xl">{f.name}</h3></div>
          </div>
          <div className="border-b border-white/15 py-6">
            <p className="text-xl text-fg">{f.full}</p>
            <p className="mt-3 max-w-md text-base leading-relaxed text-fg-2">{f.id === "hash" ? "A decade at sea and in shipping. MIT-trained engineer, building across logistics and robotics." : "IIT-trained engineer. Former Microsoft Research fellow, building AI and intelligent systems for over a decade."}</p>
            <div className="mt-4 flex flex-wrap gap-6">{f.links.map((l) => <a key={l.href} href={l.href} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-11 items-center gap-1 text-sm text-fg-2 hover:text-signal">{l.label}<ArrowUpRight className="h-3.5 w-3.5" /></a>)}</div>
          </div>
        </Reveal>)}
      </div>
    </div>
  </section>
);
